// extracted by mini-css-extract-plugin
export default {"item":"CardImage_item__GqWKK","image":"CardImage_image__war5N","text":"CardImage_text__zb9b0"};